module.exports = __webpack_public_path__ + "static/assets/ecea3eba4a9e187eb6cc7cc6a6b4bb4d.mp3";